import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import AdminSectionCard from '@components/admin/AdminSectionCard';
import { buildAdminSections } from '@components/admin/adminSections';
import { usePermissions } from '../hooks/usePermissions';

const AdminPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const permissions = usePermissions();

  const availableSections = buildAdminSections(t, permissions).filter(
    (section) => section.permission,
  );

  return (
    <div>
      <h4 className="revy-cjk mb-2 text-2xl font-semibold leading-[1.4] tracking-tight">
        {t('admin.title')}
      </h4>
      <p className="revy-cjk mb-8 text-base leading-[1.6] text-muted-foreground">
        {t('admin.description')}
      </p>

      {/* MUI's sm/md are 600/900, not Tailwind's 640/768 — arbitrary queries
          keep the original wrap points. */}
      <div className="grid grid-cols-1 gap-6 min-[600px]:grid-cols-2 min-[900px]:grid-cols-3">
        {availableSections.map((section) => (
          <AdminSectionCard key={section.path} section={section} onOpen={navigate} />
        ))}
      </div>

      {availableSections.length === 0 && (
        <div className="flex min-h-[40vh] items-center justify-center">
          <p className="revy-cjk text-base leading-[1.6] text-muted-foreground">
            {t('admin.noPermission')}
          </p>
        </div>
      )}
    </div>
  );
};

export default AdminPage;
